// /*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { activatePropertyOffer, listAllPropertyOffers, resetAllPropertyOffers, syncPropertyOffer } from '../../../store/actions';
import { useSelector } from 'react-redux';
import { Box, Button, Stack, Typography } from '@mui/material';
import { DataGrid, GridFooterContainer } from '@mui/x-data-grid';
import { tableStyle } from '../../../components';
import { Add, ArrowForward, Sync } from '@mui/icons-material';
import moment from 'moment';
import AvailabilityUpdation from '../../../components/AvailabilityUpdation';
import ButtonWithConfirmModal from '../../../components/ButtonWithConfirmModal';
import AddNewRate from './addNewRate';
import { useNavigate } from 'react-router-dom';

function PropertyWiseOccupancy({ dispatch, colors }) {
    const navigate = useNavigate();
    const [isAdding, setIsAdding] = useState(false);

    const { offersList, showViewMore } = useSelector((state) => ({
        offersList: state?.roomtypes?.propertyOffers?.list || [],
        showViewMore: Boolean(state?.roomtypes?.propertyOffers?.showViewMore),
    }));

    useEffect(() => {
        dispatch(resetAllPropertyOffers());
        fetchMoreData();
        // eslint-disable-next-line
    }, []);

    const fetchMoreData = () => {
        dispatch(listAllPropertyOffers());
    };

    const CustomFooter = () => {
        return (
            <GridFooterContainer>
                <Stack width="100%" alignItems="center">
                    {showViewMore ? (
                        <Button fullWidth onClick={fetchMoreData}>
                            <b>view more</b>
                        </Button>
                    ) : (
                        <Typography variant="h6">All datas listed</Typography>
                    )}
                </Stack>
            </GridFooterContainer>
        );
    };

    const columns = [
        {
            field: "start_date",
            headerName: "Start date",
            width: 140,
            cellClassName: "name-column--cell",
            valueGetter: (params) => `${params.row.start_date ? moment.unix(params.row.start_date).format("DD-MMM-YYYY") : "-"}`,
        },
        {
            field: "end_date",
            headerName: "End date",
            width: 140,
            cellClassName: "name-column--cell",
            valueGetter: (params) => `${params.row.end_date ? moment.unix(params.row.end_date).format("DD-MMM-YYYY") : "-"}`,
        },
        { 
            field: "type", 
            headerName: "Rate type", 
            width: 120,
            renderCell: ({ row: { type } }) => <Typography textTransform={"capitalize"}>{type ? type?.replace("_", " ") : "-"}</Typography>
        },
        {
            field: "",
            headerName: "Open",
            width: 100,
            renderCell: ({ row: { _id } }) => {
                return (
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={async () => {
                            navigate(`/property-offer-details/${_id}`);
                        }}
                        endIcon={<ArrowForward fontSize="small" />}
                        sx={{ fontWeight: 700 }}
                    >
                        View
                    </Button>
                );
            },
        },
        {
            field: "is_active",
            headerName: "Availability",
            width: 100,
            renderCell: ({ row: { is_active, _id } }) => {
                return (
                    <AvailabilityUpdation
                        isActive={is_active}
                        action={() => dispatch(activatePropertyOffer({ id: _id }))}
                    />
                );
            },
        },
        {
            field: "_id",
            headerName: "Sync",
            width: 130,
            renderCell: ({ row: { _id } }) => {
                return (
                    <ButtonWithConfirmModal
                        BtnLabel="Sync"
                        text="Are you sure to sync ?"
                        action={() => dispatch(syncPropertyOffer({ id: _id }))}
                        btnIcon={<Sync />}
                    />
                );
            },
        },
        {
            field: "last_sync",
            headerName: "Last sync",
            width: 180,
            renderCell: ({ row: { last_sync } }) => last_sync ? moment.unix(last_sync).format("DD-MMM-YYYY - HH:mm") : "-",
        },
        {
            field: "sync_status",
            headerName: "Sync status",
            width: 120,
            renderCell: ({ row: { sync_status } }) => sync_status ? sync_status : "-",
        },
    ];

    return (
        <Box mb={15}>
            {!isAdding ? (
                <>
                    <Stack
                        direction={"row"}
                        justifyContent={"flex-end"}
                        alignItems={"end"}
                        mb={2}
                    >
                        <Box>
                            <Button
                                sx={{
                                    backgroundColor: colors.blueAccent[700],
                                    color: colors.grey[100],
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    padding: "10px 20px",
                                }}
                                onClick={() => setIsAdding(true)}
                            >
                                <Add sx={{ mr: "10px" }} />
                                Add new rate
                            </Button>
                        </Box>
                    </Stack>
                    <Box
                        m="8px 0 0 0"
                        height="350px"
                        sx={tableStyle(colors)}
                    >
                        <DataGrid
                            rows={offersList}
                            columns={columns}
                            components={{ Footer: CustomFooter }}
                            getRowId={(row) => row?._id}
                        />
                    </Box>
                </>
            ) : (
                <AddNewRate
                    colors={colors}
                    dispatch={dispatch}
                    setIsAdding={setIsAdding}
                />
            )}
        </Box>
    );
}

export default PropertyWiseOccupancy;
